var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3452 6.94941H28.1312V21.4123H7.24043V24.6262C7.24043 25.5101 7.96357 26.2332 8.84741 26.2332H26.5242L32.9521 32.6611V8.5564C32.9521 7.67256 32.229 6.94941 31.3452 6.94941ZM24.9172 16.5913V2.12847C24.9172 1.24463 24.1941 0.521484 23.3103 0.521484H2.41948C1.53564 0.521484 0.8125 1.24463 0.8125 2.12847V24.6262L7.24043 18.1983H23.3103C24.1941 18.1983 24.9172 17.4751 24.9172 16.5913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.340ad0e27dbd4293f9a3d8cb9af670d4.svg";
export { ForwardRef as ReactComponent };